import { AccountInfo, AccountInfoSkeleton } from "../AccountInfo";
import { Bell, Building, User } from "lucide-react";
import { TabsList, TabsTrigger } from "@facade/components/ui";

import { AccountSideMenuProps } from "./AccountSideMenu.types";
import { Suspense } from "react";

export const AccountSideMenu = ({
  onOrganizationsIntent,
  onNotificationsIntent,
}: AccountSideMenuProps) => {
  return (
    <div className="flex flex-col w-72 gap-4">
      <div className="flex items-center gap-3">
        <Suspense fallback={<AccountInfoSkeleton />}>
          <AccountInfo />
        </Suspense>
      </div>
      <TabsList className="w-full">
        <TabsTrigger value="profile">
          <User /> Profile
        </TabsTrigger>
        <TabsTrigger
          value="organizations"
          onMouseEnter={onOrganizationsIntent}
          onFocus={onOrganizationsIntent}
        >
          <Building />
          Organizations
        </TabsTrigger>
        <TabsTrigger
          value="notifications"
          onMouseEnter={onNotificationsIntent}
          onFocus={onNotificationsIntent}
        >
          <Bell />
          Notifications
        </TabsTrigger>
      </TabsList>
    </div>
  );
};
